import React, { useState, useEffect } from "react";
import TestimonialSection from "./TestimonialSection";

const KEYS = ["ashley", "liam", "barbara"];

export default function TestimonialCarousel({ isMobile, autoAdvanceMs = 9000 }) {
  const [active, setActive] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused || !autoAdvanceMs) return;
    const id = setInterval(
      () => setActive((i) => (i + 1) % KEYS.length),
      autoAdvanceMs
    );
    return () => clearInterval(id);
  }, [paused, autoAdvanceMs]);

  const go = (delta) =>
    setActive((i) => (i + delta + KEYS.length) % KEYS.length);

  return (
    <div
      style={{ position: "relative" }}
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <TestimonialSection
        key={KEYS[active]}
        isMobile={isMobile}
        testimonial={KEYS[active]}
      />

      <button
        aria-label="Previous testimonial"
        onClick={() => go(-1)}
        style={arrowStyle("left", isMobile)}
      >
        ‹
      </button>
      <button
        aria-label="Next testimonial"
        onClick={() => go(1)}
        style={arrowStyle("right", isMobile)}
      >
        ›
      </button>

      <div
        style={{
          position: "absolute",
          bottom: isMobile ? "1rem" : "1.5rem",
          left: 0,
          right: 0,
          display: "flex",
          justifyContent: "center",
          gap: "0.5rem",
          zIndex: 2,
        }}
      >
        {KEYS.map((k, i) => (
          <button
            key={k}
            aria-label={`Show testimonial ${i + 1}`}
            onClick={() => setActive(i)}
            style={{
              width: i === active ? "24px" : "8px",
              height: "8px",
              borderRadius: "999px",
              border: "none",
              padding: 0,
              background:
                i === active ? "rgba(255,255,255,0.9)" : "rgba(255,255,255,0.35)",
              cursor: "pointer",
              transition: "all 0.25s",
            }}
          />
        ))}
      </div>
    </div>
  );
}

function arrowStyle(side, isMobile) {
  return {
    position: "absolute",
    top: "50%",
    [side]: isMobile ? "0.5rem" : "1.5rem",
    transform: "translateY(-50%)",
    width: isMobile ? "36px" : "44px",
    height: isMobile ? "36px" : "44px",
    borderRadius: "50%",
    border: "1px solid rgba(255,255,255,0.2)",
    background: "rgba(0,0,0,0.35)",
    color: "#fff",
    fontSize: "1.4rem",
    cursor: "pointer",
    zIndex: 2,
    backdropFilter: "blur(8px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    lineHeight: 1,
    paddingBottom: "3px",
  };
}
